<template>
    <section>
        <div class="ui basic segment">
            <a @click="$router.go(-1)" class="ui left basic button">
                <i class="reply icon"></i>Regresar
            </a>
            <h2 class="ui grey right floated header">
                Administración de Roles
            </h2>
        </div>

        <sui-segment basic class="mb-0 p-0 mt-0">
            <sui-form>
                <sui-form-fields fields="two">
                    <sui-form-field>
                        <label>Selecciona un rol</label>
                        <sui-dropdown
                            fluid
                            :options="roleOptions"
                            placeholder="Seleccionar rol"
                            selection
                            v-model="selectedRoleId"
                            @input="onRoleSelected"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>&nbsp;</label>
                        <div style="text-align: right;">
                            <button type="button" @click="openAddModal" class="ui green button">
                                <i class="plus icon"></i> Agregar usuario
                            </button>
                        </div>
                    </sui-form-field>
                </sui-form-fields>
            </sui-form>
        </sui-segment>
        <div class="tableFixHead">
            <sui-table color="black" celled>
                <sui-table-header>
                    <sui-table-row>
                        <sui-table-header-cell :width="4">Nombre</sui-table-header-cell>
                        <sui-table-header-cell :width="3">Correo</sui-table-header-cell>
                        <sui-table-header-cell :width="1">RFC</sui-table-header-cell>
                        <sui-table-header-cell :width="1">Celular</sui-table-header-cell>
                        <sui-table-header-cell :width="2" v-if="isFloreserRole">Cobradora</sui-table-header-cell>
                        <sui-table-header-cell :width="2" v-if="isFloreserRole">Zona / Localidad</sui-table-header-cell>
                        <sui-table-header-cell :width="2" textAlign="center">Acciones</sui-table-header-cell>
                    </sui-table-row>
                </sui-table-header>
                <sui-table-body>
                    <sui-table-row v-if="usersInRole.length === 0">
                        <sui-table-cell textAlign="center" colspan="4">
                            <strong>No hay usuarios con este rol</strong>
                        </sui-table-cell>
                    </sui-table-row>
                    <sui-table-row v-for="user in usersInRole" :key="user.id">
                        <sui-table-cell>{{ user.fullName }}</sui-table-cell>
                        <sui-table-cell>{{ user.email }}</sui-table-cell>
                        <sui-table-cell>{{ user.rfc }}</sui-table-cell>
                        <sui-table-cell>{{ user.cellphone }}</sui-table-cell>
                        <sui-table-cell v-if="isFloreserRole">
                            <span v-if="user.supervision && user.supervision.supervisor">
                                {{ user.supervision.supervisor.fullName }}
                            </span>
                            <span v-else class="no-users-text">No definido</span>
                        </sui-table-cell>
                        <sui-table-cell v-if="isFloreserRole">
                                {{ user.zone && user.zone.name }}
                        </sui-table-cell>
                        <sui-table-cell textAlign="center">
                            <sui-dropdown text="Acciones" button size="mini" color="blue">
                                <sui-dropdown-menu>
                                    <sui-dropdown-item v-if="isFloreserRole" @click="openAssignCollectorModal(user)">
                                        <i class="user plus icon blue"></i>
                                        {{ user.supervision ? 'Cambiar Cobradora' : 'Asignar Cobradora' }}
                                    </sui-dropdown-item>
                                    <sui-dropdown-item @click="confirmRemove(user)">
                                        <i class="trash icon red"></i> Quitar
                                    </sui-dropdown-item>
                                </sui-dropdown-menu>
                            </sui-dropdown>
                        </sui-table-cell>
                    </sui-table-row>
                </sui-table-body>
            </sui-table>
        </div>

        <sui-modal size="small" v-model="showAddModal">
            <sui-modal-header>Agregar usuario al rol: {{ selectedRoleName }}</sui-modal-header>
            <sui-modal-content>
                <sui-form>
                    <sui-form-field required>
                        <label>Usuario</label>
                        <sui-dropdown
                            fluid
                            :options="allUserOptions"
                            placeholder="Buscar usuario..."
                            selection
                            search
                            v-model="selectedUserId"
                        />
                    </sui-form-field>
                    <sui-form-field v-if="isFloreserRole" required>
                        <label>Locación</label>
                        <sui-dropdown
                            placeholder="Selecciona locación..."
                            selection
                            search
                            :options="zonesOptions"
                            v-model="locationInput"
                        />
                    </sui-form-field>
                    <sui-form-field v-if="isFloreserRole" required>
                        <label>Cobradora</label>
                        <sui-dropdown
                            fluid
                            placeholder="Selecciona una cobradora..."
                            selection
                            search
                            :options="collectorOptions"
                            v-model="selectedCollectorId"
                        />
                    </sui-form-field>
                </sui-form>
            </sui-modal-content>
            <sui-modal-actions>
                <sui-button @click="showAddModal = false">Cancelar</sui-button>
                <sui-button primary @click="assignRole">Agregar</sui-button>
            </sui-modal-actions>
        </sui-modal>

        <!-- Modal: seleccionar sustituto antes de quitar (promotor / recuperador) -->
        <sui-modal size="small" v-model="showReplacementModal">
            <sui-modal-header>
                Asignar sustituto
            </sui-modal-header>
            <sui-modal-content>
                <p>
                    {{ userToRemove && userToRemove.fullName }} será removido del rol.
                    <br> Selecciona un sustituto que tomará sus clientes y créditos como {{ selectedRoleName.toLowerCase() }}.
                </p>
                <sui-form>
                    <sui-form-field required>
                        <label>Sustituto</label>
                        <sui-dropdown
                            fluid
                            :options="replacementUserOptions"
                            placeholder="Buscar sustituto..."
                            selection
                            search
                            v-model="replacementUserId"
                        />
                    </sui-form-field>
                </sui-form>
            </sui-modal-content>
            <sui-modal-actions>
                <sui-button @click="showReplacementModal = false">Cancelar</sui-button>
                <sui-button negative @click="confirmReassignAndRemove">Quitar y transferir</sui-button>
            </sui-modal-actions>
        </sui-modal>

        <!-- Modals -->
        <reassign-credits-and-remove-modal
            :show-modal="showReassignCreditsAndRemoveModal"
            :collector="collectorToRemove"
            :credits="credits"
            :replacement-collector-options="replacementCollectorOptions"
            @modalResponse="onReassignAndRemoveResponse"
        />

        <assign-collector-modal
            :show-modal="showAssignCollectorModal"
            :promoter="selectedPromoter"
            :collector-options="collectorOptions"
            @modalResponse="onAssignCollectorResponse"
        />
    </section>
</template>

<script>
import GenericService from '@/services/GenericService'
import Utils from '@/common/Utils'
import Roles from '@/common/Roles'
import ReassignCreditsAndRemoveModal from '@/components/Modals/ReassignCreditsAndRemoveModal.vue'
import AssignCollectorModal from '@/components/Modals/AssignCollector.vue'
import UserSupervisionService from '@/services/UserSupervisionService'

export default {
    name: 'RoleManagement',
    components: { ReassignCreditsAndRemoveModal, AssignCollectorModal },
    data () {
        return {
            roles: [],
            specialRoles: {},
            selectedRoleId: null,
            usersInRole: [],
            allUsers: [],
            showAddModal: false,
            selectedUserId: null,
            showReplacementModal: false,
            userToRemove: null,
            replacementUserId: null,
            locationInput: '',
            showReassignCreditsAndRemoveModal: false,
            showAssignCollectorModal: false,
            selectedCollectorId: null,
            collectorToRemove: null,
            selectedPromoter: null,
            creditsAction: null,
            collectors: [],
            credits: [],
            zones: []
        }
    },
    computed: {
        roleOptions () {
            return this.roles.map(r => ({ value: r.id, text: r.name }))
        },
        selectedRoleName () {
            const role = this.roles.find(r => r.id === this.selectedRoleId)
            return role ? role.name : ''
        },
        isReassignRole () {
            if (!this.selectedRoleId) return false
            const role = this.roles.find(r => r.id === this.selectedRoleId)
            if (!role) return false
            const list = this.specialRoles.reassignRoles || []
            return list.includes(role.name.toUpperCase())
        },
        isFloreserRole () {
            if (!this.selectedRoleId || !this.specialRoles.promotorFloreser) return false
            const role = this.roles.find(r => r.id === this.selectedRoleId)
            return !!(role && role.name.toUpperCase() === this.specialRoles.promotorFloreser.toUpperCase())
        },
        allUserOptions () {
            const idsInRole = new Set(this.usersInRole.map(u => u.id))
            return this.allUsers
                .filter(u => !idsInRole.has(u.id))
                .map(u => ({ value: u.id, text: u.fullName.toUpperCase() || u.email }))
                .sort((a, b) => a.text.localeCompare(b.text))
        },
        replacementUserOptions () {
            const excludeId = this.userToRemove ? this.userToRemove.id : null
            return this.usersInRole
                .filter(u => u.id !== excludeId)
                .map(u => ({ value: u.id, text: u.fullName.toUpperCase() || u.email }))
                .sort((a, b) => a.text.localeCompare(b.text))
        },
        zonesOptions () {
            return this.zones
                .filter(z => z.active)
                .map(z => ({ value: z.name, text: z.name }))
        },
        collectorOptions () {
            return this.collectors
                .map(c => ({ value: c.id, text: c.fullName.toUpperCase() }))
                .sort((a, b) => a.text.localeCompare(b.text))
        },
        isPaymentCollectorRole () {
            return this.selectedRoleId === Roles.COBRADORA_FLORESER
        },
        replacementCollectorOptions () {
            const excludeId = this.collectorToRemove ? this.collectorToRemove.id : null
            return this.collectors
                .filter(c => c.id !== excludeId)
                .map(c => ({ value: c.id, text: c.fullName.toUpperCase() }))
                .sort((a, b) => a.text.localeCompare(b.text))
        }
    },
    beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
        this.fetchRoles()
        this.fetchZones()
    },
    methods: {
        async fetchRoles () {
            const loader = this.$loading.show()
            try {
                const { data, specialRoles } = await GenericService.getAll('/roles')
                this.roles = data
                this.specialRoles = specialRoles || {}
                if (data.length > 0) {
                    this.selectedRoleId = data[0].id
                    this.onRoleSelected()
                }
            } catch (error) {
                console.error(error)
            } finally {
                loader.hide()
            }
        },
        async onRoleSelected () {
            if (!this.selectedRoleId) return
            this.usersInRole = []
            const role = this.roles.find(r => r.id === this.selectedRoleId)
            if (!role) return
            const loader = this.$loading.show()
            try {
                const { data } = await GenericService.getAll('/users', { roleName: role.name, active: true })
                this.usersInRole = (data.items || []).sort((a, b) => a.fullName.localeCompare(b.fullName))
            } catch (error) {
                console.error(error)
            } finally {
                loader.hide()
            }
        },
        async loadAllUsers () {
            if (this.allUsers.length > 0) return
            const loader = this.$loading.show()
            try {
                const { data } = await GenericService.getAll('/users', { showBasic: true, active: true })
                this.allUsers = data.items || []
            } catch (error) {
                console.error(error)
            } finally {
                loader.hide()
            }
        },
        async openAddModal () {
            if (!Utils.userHasPerm('can_edit_user_roles')) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar'
                })
                return
            }
            this.selectedUserId = null
            this.locationInput = ''
            this.showAddModal = true
            await this.loadAllUsers()
            if (!this.collectors.length) {
                await this.fetchCollectors()
            }
        },
        async assignRole () {
            if (!this.selectedUserId) {
                this.$swal({
                    icon: 'warning',
                    title: 'Selecciona un usuario',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
                return
            }
            if (this.isFloreserRole) {
                if (!this.locationInput || !this.selectedCollectorId) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Selecciona un locación y cobradora',
                        toast: true,
                        timer: 3000,
                        position: 'top',
                        showConfirmButton: false
                    })
                    return
                }
            }
            const loader = this.$loading.show()
            try {
                await GenericService.create('/userRole/assign', {
                    targetUserId: this.selectedUserId,
                    roleId: this.selectedRoleId,
                    location: this.locationInput.toUpperCase()
                })
                if (this.isFloreserRole) {
                    this.creditsAction = 'keep'
                    await this.assignPaymentCollector(this.selectedUserId)
                    this.selectedCollectorId = null
                    this.creditsAction = null
                }
                this.$swal({
                    icon: 'success',
                    title: 'Usuario agregado al rol',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
                this.showAddModal = false
                this.onRoleSelected()
            } catch (error) {
                console.error(error)
                this.$swal({
                    icon: 'error',
                    title: error?.data?.message || 'No se pudo agregar el usuario al rol',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
            } finally {
                loader.hide()
            }
        },
        async confirmRemove (user) {
            if (!Utils.userHasPerm('can_edit_user_roles')) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar'
                })
                return
            }

            if (this.isPaymentCollectorRole) {
                const loader = this.$loading.show()
                let promoters = []
                this.credits = []
                try {
                    promoters = await UserSupervisionService.getPromotersByPaymentCollector(user.id)
                    if (!promoters.length) {
                        this.credits = await UserSupervisionService.getCreditsByPaymentCollector(user.id)
                    }
                } catch (error) {
                    console.error(error)
                } finally {
                    loader.hide()
                }
                if (promoters.length > 0) {
                    this.$swal({
                        title: 'Cobradora tiene promotoras asignadas.',
                        html: 'Favor de reasignar las promotoras a otra cobradora para continuar.',
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Cerrar'
                    })
                    return
                }

                this.collectorToRemove = user
                this.replacementCollectorId = null
                await this.fetchCollectors()
                this.showReassignCreditsAndRemoveModal = true
            } else if (this.isReassignRole) {
                this.userToRemove = user
                this.replacementUserId = null
                await this.loadAllUsers()
                this.showReplacementModal = true
            } else {
                this.$swal({
                    title: `¿Deseas quitar a ${user.fullName || user.username} del rol ${this.selectedRoleName}?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, quitar',
                    cancelButtonText: 'Cancelar'
                }).then(result => {
                    if (result.value) this.removeRole(user)
                })
            }
        },
        async confirmReassignAndRemove () {
            if (!this.replacementUserId) {
                this.$swal({
                    icon: 'warning',
                    title: 'Selecciona un sustituto',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
                return
            }
            const loader = this.$loading.show()
            try {
                await GenericService.create('/userRole/reassign-and-remove', {
                    oldTargetUserId: this.userToRemove.id,
                    newTargetUserId: this.replacementUserId,
                    roleId: this.selectedRoleId
                })
                this.$swal({
                    icon: 'success',
                    title: 'Usuario removido y asignaciones transferidas',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
                this.showReplacementModal = false
                this.userToRemove = null
                this.onRoleSelected()
            } catch (error) {
                console.error(error)
                this.$swal({
                    icon: 'error',
                    title: error?.data?.message || 'No se pudo completar la operación',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
            } finally {
                loader.hide()
            }
        },
        async removeRole (user) {
            const loader = this.$loading.show()
            try {
                await GenericService.create('/userRole/remove', {
                    targetUserId: user.id,
                    roleId: this.selectedRoleId
                })
                this.$swal({
                    icon: 'success',
                    title: 'Rol removido',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
                this.onRoleSelected()
            } catch (error) {
                console.error(error)
                this.$swal({
                    icon: 'error',
                    title: error?.data?.message || 'No se pudo quitar el rol al usuario',
                    toast: true,
                    timer: 3000,
                    position: 'top',
                    showConfirmButton: false
                })
            } finally {
                loader.hide()
            }
        },
        async fetchZones () {
            this.loader = this.$loading.show()
            let { data } = await GenericService.getAll('/zones')
            this.zones = data
            this.loader.hide()
        },
        async fetchCollectors () {
            const loader = this.$loading.show()
            try {
                const { data } = await GenericService.getAll('/users', { roleName: 'COBRADORA FLORESER', active: true })
                this.collectors = data.items || []
            } catch (error) {
                console.error(error)
            } finally {
                loader.hide()
            }
        },
        async openAssignCollectorModal (user) {
            if (!Utils.userHasPerm('can_edit_user_relations')) {
                this.$swal({
                    title: 'No tienes permiso para realizar la acción',
                    html: 'Debes solicitar permiso al administrador',
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Cerrar'
                })
                return
            }
            this.selectedPromoter = user
            this.showAssignCollectorModal = true
            if (!this.collectors.length) {
                await this.fetchCollectors()
            }
        },
        async assignPaymentCollector (subordinateId = null) {
            const promoterId = subordinateId || this.selectedPromoter.id

            await GenericService.executeAction('/userSupervisions/subordinateAssign', {
                supervisorId: this.selectedCollectorId,
                subordinateId: promoterId,
                creditsAction: this.creditsAction
            })
            this.selectedCollectorId = null
        },
        async onAssignCollectorResponse (record) {
            this.showAssignCollectorModal = false
            if (record.cancel) return

            try {
                await GenericService.executeAction('/userSupervisions/subordinateAssign', {
                    supervisorId: record.selectedCollectorId,
                    subordinateId: this.selectedPromoter.id,
                    creditsAction: record.creditsAction
                })
                await this.onRoleSelected()
            } catch (error) {
                const msg = (error.data || {}).message || 'No se pudo asignar la cobradora.'
                this.$swal({
                    icon: 'warning',
                    title: 'Hubo un error',
                    text: msg,
                    timer: 4000,
                    position: 'top',
                    showConfirmButton: false
                })
            }
        },
        async onReassignAndRemoveResponse (record) {
            this.showReassignCreditsAndRemoveModal = false
            if (record.cancel) return

            const loader = this.$loading.show()
            try {
                await GenericService.create('/userSupervisions/replace-and-remove', {
                    oldCollectorId: this.collectorToRemove.id,
                    newCollectorId: record.replacementCollectorId,
                    roleId: this.selectedRoleId
                })
                this.$swal({
                    icon: 'success',
                    title: 'Cobradora removida y creditos reasignados',
                    timer: 3000,
                    confirmButtonText: 'Cerrar'
                })
                this.onRoleSelected()
            } catch (error) {
                const msg = (error.data || {}).message || 'No se pudo completar la operación'
                this.$swal({
                    icon: 'error',
                    title: msg,
                    toast: true,
                    timer: 4000,
                    confirmButtonText: 'Cerrar'
                })
            } finally {
                loader.hide()
            }
        },
        closeAddModal () {
            this.showAddModal = false
            this.selectedUserId = null
            this.locationInput = null
            this.selectedCollectorId = null
        }
    },
    watch: {
        showAddModal (isOpen) {
            if (!isOpen) {
                this.selectedUserId = null
                this.locationInput = null
                this.selectedCollectorId = null
            }
        }
    }
}
</script>

<style scoped>
.ui.table { margin-top: 20px; }

.no-users-text {
    color: #999;
}
</style>
